import { createFinishStepContent } from '../FinishStepContent';

const inviteCoWorker = (baseUrl, navigate, user) => {
  return {
    id: 'inviteCoWorker',
    title: 'Invite a co-worker to try Releva with you',
    steps: [
      {
        id: 'goToAccountSettings',
        selector: '[data-tour="userDropdown"]',
        content: <p>Click on "Account" to access the account settings.</p>,
        actionBefore: () => document.querySelector('#domainDropdownButton')?.click(),
      },
      {
        id: 'goToCollaboratsTab',
        actionBefore: () => {
          document.querySelector('#domainDropdownButton')?.click();
          navigate(`${baseUrl}/settings/account?tab=collaborators`, true);
        },
        selector: '[data-tour="accountSettingsCollaboratorsTab"]',
        content: <p>In this tab, you can see all users that have access, their contact information, and access level.</p>,
      },
      {
        id: 'addCollaboratorButton',
        selector: '[data-tour="accountSettingsCollaboratorsTabAddButton"]',
        content: <p>Click on the "Add Collaborator" button.</p>,
      },
      {
        id: 'enterCollaboratorDetails',
        actionBefore: () => navigate(`${baseUrl}/settings/account?tab=collaborators&collaboratorModalOpen=1`, true),
        selector: '[data-tour="accountSettingsCollaboratorsTabAddButtonForm"]',
        content: (
          <>
            <p>Enter the user's contact information, choose access level, and invite them.</p>
            <p>They will receive an automated email where they are requested to create a password for Releva.</p>
            <p>
              Each user can receive the invitation email only once, after that they should go through the Forgot
              password sequence.
            </p>
          </>
        ),
        stepInteraction: true,
      },
      {
        id: 'createCollaborator',
        selector: '[data-tour="collaboratorsModalSaveBtn"]',
        content: <p>Click on the "Invite" button.</p>,
      },
      {
        id: 'collaboratorListAfterCreate',
        actionBefore: () => document.querySelector('[data-tour="collaboratorsModalSaveBtn"]')?.click(),
        selector: '[data-tour="accountSettingsCollaboratorsTab"]',
        content: <p>Success, you have created a new collaborator.</p>,
      },
      {
        id: 'backToTour',
        actionBefore: () => navigate(`${baseUrl}/guide`, true),
        selector: '[data-tour="userGuideHeading"]',
        content: createFinishStepContent(),
      },
    ],
    isComplete: !!user.userActions.find((a) => a.action === 'taskCompleted' && a.context.task === 'inviteCoWorker'),
  };
};

export default inviteCoWorker;
